<template>
  <v-card elevation="1">
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Вопрос: {{ question.text }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-col cols="12">
        <v-form ref="questionForm">
          <v-row>
            <v-text-field
              type="number"
              v-model="question.sort"
              label="Номер по порядку"
              min="0"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field v-model="question.text" name="text" label="Текст вопроса"></v-text-field>
          </v-row>
        </v-form>
        <v-row>
          <v-btn
            @click="save"
            :dark="editableQuestionWasChanged"
            :disabled="!editableQuestionWasChanged"
            color="green"
            >{{ saveButtonText }}</v-btn
          >
        </v-row>
      </v-col>
      <v-col v-if="isEdit" cols="12">
        <v-row>
          <div class="title">Варианты ответов</div>
        </v-row>
        <v-row>
          <v-list>
            <v-list-item
              v-for="option in question.options"
              :key="option.id"
              @click="setCurrentOption(option)"
            >
              <v-list-item-icon>
                <v-icon v-if="option.valid" color="green">mdi-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ option.text }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon color="red" @click.stop="deleteOption(option)">
                  mdi-close-circle-outline
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-row>
        <v-col cols="12">
          <v-btn @click="setCurrentOption()" color="primary" outlined>Добавить ответ</v-btn>
        </v-col>
      </v-col>
    </v-card-text>
    <v-dialog v-model="optionModal" max-width="500">
      <v-card>
        <v-toolbar dark flat color="orange">
          <v-toolbar-title>Вариант ответа к вопросу: {{ question.text }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon @click="optionModal = false">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-text-field v-model="option.text" label="Текст ответа" name="text"></v-text-field>
          <v-switch
            v-model="option.valid"
            :label="getOptionSwitchButtonText(option.valid)"
            name="valid"
            color="green"
          ></v-switch>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="green"
            :dark="editableOptionWasChanged"
            @click="saveOption"
            :disabled="!editableOptionWasChanged"
            >Сохранить</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import * as pollAPI from '@/api/polls'
import forms from '@/mixins/forms'

export default {
  name: 'Question',
  mixins: [forms],
  props: {
    pollId: { type: String, required: true },
    questionId: { type: String, required: false, default: '' },
    resetOnCreate: { type: Boolean, default: false },
    initialQuestion: {
      type: Object,
      default: () => {
        return { ...pollAPI.DEFAULT_QUESTION }
      },
    },
  },
  data() {
    return {
      optionModal: false,
      change: true,
      originalQuestion: { ...pollAPI.DEFAULT_QUESTION },
      question: { ...pollAPI.DEFAULT_QUESTION },
      option: { ...pollAPI.DEFAULT_OPTION },
      currentSelectedOption: { ...pollAPI.DEFAULT_OPTION },
    }
  },
  computed: {
    isEdit() {
      return !!this.question.id
    },
    editableOptionWasChanged() {
      return !(
        this.option.text === this.currentSelectedOption.text &&
        this.option.valid === this.currentSelectedOption.valid
      )
    },
    editableQuestionWasChanged() {
      return !(
        this.question.text === this.originalQuestion.text &&
        Number(this.question.sort) === Number(this.originalQuestion.sort)
      )
    },
    saveButtonText() {
      if (this.isEdit) {
        return 'Обновить'
      }
      return 'Добавить'
    },
  },
  watch: {
    initialQuestion(x) {
      this.question = { ...x }
      this.originalQuestion = { ...this.question }
    },
  },
  mounted() {
    if (this.questionId) {
      this.question.id = this.questionId
    }
    if (this.initialQuestion.id) {
      this.question = { ...this.initialQuestion }
      this.originalQuestion = { ...this.question }
    }
    if (this.questionId && !this.initialQuestion.id) {
      this.getQuestion()
    }
  },
  methods: {
    getOptionSwitchButtonText(valid) {
      if (valid) {
        return 'Правильный ответ'
      }
      return 'Не правильный ответ'
    },
    setCurrentOption(option) {
      if (!option) {
        option = { ...pollAPI.DEFAULT_OPTION }
      }
      this.option = { ...option }
      this.currentSelectedOption = { ...option }
      this.optionModal = true
    },
    deleteOption(option) {
      pollAPI
        .deleteQuestionOption(this.axios, option.id)
        .then((resp) => {
          this.showSnackbar(this.messages.successUpdated, 'success')
          this.getQuestion()
        })
        .catch((err) => {
          this.showSnackbar(err, 'error')
        })
    },
    saveOption() {
      if (!this.editableOptionWasChanged) {
        return
      }
      if (this.option.id) {
        pollAPI
          .updateQuestionOption(this.axios, this.option.id, this.question.id, {
            text: this.option.text,
            valid: this.option.valid,
          })
          .then((resp) => {
            this.option = { ...pollAPI.DEFAULT_OPTION }
            this.getQuestion()
            this.optionModal = false
            this.$emit('question-updated', this.question)
          })
          .catch((err) => this.showSnackbar(err.response ? err.response.data : err, 'error'))
      } else {
        pollAPI
          .addQuestionOption(this.axios, this.question.id, {
            text: this.option.text,
            valid: this.option.valid,
          })
          .then((resp) => {
            this.option = { ...pollAPI.DEFAULT_OPTION }
            this.getQuestion()
            this.optionModal = false
            this.$emit('question-updated', this.question)
          })
          .catch((err) => this.showSnackbar(err.response ? err.response.data : err, 'error'))
      }
    },
    save() {
      if (!this.isEdit) {
        this.createQuestion()
      } else {
        this.updateQuestion()
      }
    },
    getQuestion() {
      this.$log.debug('get question')
      pollAPI
        .getPollQuestion(this.axios, this.question.id)
        .then((resp) => {
          this.question = resp.data
          this.originalQuestion = { ...this.question }
        })
        .catch((err) => this.showSnackbar(err.response ? err.response.data : err, 'error'))
    },
    createQuestion() {
      if (!this.$refs.questionForm.validate()) {
        this.showSnackbar(this.messages.needFillAllRequiredFields, 'error')
        return
      }
      pollAPI
        .createPollQuestion(this.axios, this.pollId, this.question.text, this.question.sort)
        .then((resp) => {
          this.question = resp.data
          this.$emit('question-created', this.question)
          if (this.resetOnCreate) {
            this.question = { ...pollAPI.DEFAULT_QUESTION }
          }
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    updateQuestion() {
      pollAPI
        .updatePollQuestion(
          this.axios,
          this.question.id,
          this.pollId,
          this.question.text,
          this.question.sort
        )
        .then((resp) => {
          this.question = resp.data
          this.$emit('question-updated', this.question)
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
}
</script>
